<template>
  <div>
    <div :class="$style.topbar">
      <Logo v-if="settings.menuLayoutType === 'nomenu'" />
      <div class="mr-auto"></div>
      <div class="mr-4 d-none d-sm-block">
        <Actions />
      </div>
      <div>
        <UserMenu :auth="me" />
      </div>
      <a-spin v-if="loadingMe">
        <a-icon slot="indicator" type="loading" style="font-size: 24px;" spin />
      </a-spin>
    </div>
    <!-- <SubMenu /> -->
  </div>
</template>

<script>
import store from "store";
import { mapState } from "vuex";
import gql from "graphql-tag";

import Logo from "../Logo/index";
import Actions from "./Actions";
import UserMenu from "./UserMenu";
import SubMenu from "./SubMenu";

const queryMe = gql`
  query {
    me {
      id
      username
      email
      fullname
      department {
        id
        name
      }
      position {
        id
        name
      }
      departmentMangers {
        id
        name
      }
      employeeId
    }
  }
`;

export default {
  components: {
    Logo,
    Actions,
    UserMenu,
    // SubMenu,
  },
  data() {
    return {
      menuData: [],
      selectedKeys: [],
      openKeys: [],
      me: {},
      loadingMe: false,
      visible: false,
    };
  },
  computed: {
    ...mapState(["settings"]),
    msToken() {
      return this.$store.state.auth.msToken;
    },
    token() {
      return this.$store.state.auth.token;
    },
  },
  mounted() {
    if (this.token) this.onGetMe();
  },
  methods: {
    onGetMe() {
      this.loadingMe = true;
      this.$apollo
        .query({
          query: queryMe,
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.me) {
            this.me = { ...data.me };
          }
          this.loadingMe = false;
        })
        .catch((error) => {
          this.loadingMe = true;
          // this.$notification.error({
          //   message: "Error",
          //   description: "Cannot get item",
          // });
          console.log("Cannot get item", error);
        });
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
